import React from "react";
import { AccrualActivityList } from "./AccrualActivityList";
import {
    AccrualActivityResourceType,
    useAccrualActivity,
} from "./useAccrualActivity";

interface AccrualActivityPanelProps {
    resourceType: AccrualActivityResourceType;
    resourceId: string;
    entityId: number;
}

/**
 * @purpose Activity body for a details panel whose accordion already renders
 * the "Activity" header and owns the expand state. The accordion only mounts
 * this on expand, so the log is fetched unconditionally here.
 */
export const AccrualActivityPanel: React.FC<AccrualActivityPanelProps> = ({
    resourceType,
    resourceId,
    entityId,
}) => {
    const activity = useAccrualActivity({
        resourceType,
        resourceId,
        isEnabled: true,
    });

    return (
        <AccrualActivityList
            activity={activity}
            resourceType={resourceType}
            resourceId={resourceId}
            entityId={entityId}
        />
    );
};
